import { Badge } from "@radix-ui/themes";
import { FC } from "react";

const STATUS_COLORS: Record<string, "green" | "blue" | "yellow" | "red" | "gray" | "orange" | "purple"> = {
  active: "green",
  completed: "green",
  resolved: "green",
  processing: "blue",
  in_progress: "blue",
  pending: "yellow",
  queued: "yellow",
  fired: "orange",
  failed: "red",
  canceled: "red",
  archived: "gray",
  dismissed: "gray",
  paused: "gray",
  ignored: "gray",
  high: "red",
  normal: "blue",
  low: "gray",
  system: "purple",
  action: "blue",
  user: "green",
  assistant: "blue",
  bot: "orange",
};

interface StatusBadgeProps {
  status: string;
  size?: "1" | "2" | "3";
}

export const StatusBadge: FC<StatusBadgeProps> = ({ status, size = "1" }) => {
  const color = STATUS_COLORS[status] ?? "gray";
  return (
    <Badge color={color} variant="soft" size={size}>
      {status}
    </Badge>
  );
};
